import React from 'react';
import { CardWithTitleAndDescription } from '../Cards/CardWithTitleAndDescription/CardWithTitleAndDescription';
import {
  CardsWrapper,
  Description,
  DescriptionWrapper,
  Section,
  StickyWrapper,
  Subtitle,
  Title,
  TitleWrapper,
  Wrapper,
} from './whyYouNeedDiscovery.styles';
import { IProps, IStep } from './whyYouNeedDiscovery.model';

export const WhyYouNeedDiscovery = ({
  title,
  subtitle,
  description,
  steps,
  titleAs,
}: IProps) => {
  return (
    <Section>
      <Wrapper>
        <DescriptionWrapper>
          <StickyWrapper>
            <TitleWrapper as={titleAs}>
              <Title>{title}</Title>
              <Subtitle>{subtitle}</Subtitle>
            </TitleWrapper>
            <Description>{description}</Description>
          </StickyWrapper>
        </DescriptionWrapper>
        <CardsWrapper>
          {steps.map((step: IStep, index: number) => (
            <CardWithTitleAndDescription
              key={index}
              title={step.step_title}
              description={step.step_description}
            />
          ))}
        </CardsWrapper>
      </Wrapper>
    </Section>
  );
};
